import rangeRight from 'lodash/rangeRight';
import type { SelectOptions } from 'bench-internal-theme';
import formatDaySuffix from '../formatDaySuffix';

const days = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
];

export const dayOptions: SelectOptions = days.map(dayOption => ({
  label: formatDaySuffix(dayOption),
  value: Number(dayOption),
}));

const optimizationTypes = [
  { value: 'OPTIMIZED', label: 'Optimized' },
  { value: 'CANNOT_OPTIMIZE', label: 'Cannot Optimize' },
  { value: 'NOT_OPTIMIZED', label: 'Not Optimized' },
  { value: 'NOT_AVAILABLE', label: 'Not Available' },
  { value: 'OPT_OUT', label: 'Opt Out' },
];

export const optimizationOptions: SelectOptions = optimizationTypes;

export const thirdPartyLoginOptions: SelectOptions = [
  { value: true, label: 'Available' },
  { value: false, label: 'Unavailable' },
];

export const volumeOptions: SelectOptions = [
  { value: 'LOW', label: 'Low' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'HIGH', label: 'High' },
  { value: 'VERY_HIGH', label: 'Very High' },
  { value: 'NOT_APPLICABLE', label: 'N/A' },
];

const months: Array<string> = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const monthOptions: SelectOptions = months.map((label, index) => {
  const value = `0${index + 1}`.slice(-2);
  return { label, value };
});

const years = (): Array<number> => {
  const date = new Date();
  const currentYear = date.getFullYear();
  const firstActiveYear = 2000;

  return rangeRight(firstActiveYear, currentYear + 7);
};

export const yearOptions: SelectOptions = years().map(year => ({
  value: year.toString(),
  label: year.toString(),
}));

const collectionMethods = [
  { value: 'STRIPE', label: 'Stripe' },
  { value: 'SQUARE', label: 'Square' },
  { value: 'NOT_REQUIRED', label: 'Not Required' },
  { value: 'CANNOT_OPTIMIZE', label: 'Cannot Optimize' },
  { value: 'THIRD_PARTY_LOGIN', label: '3rd Party Login' },
  { value: 'OTHER_INTEGRATION', label: 'Other Integration' },
  { value: 'REQUESTED', label: 'Requested' },
];

export const collectionMethodOptions: SelectOptions = collectionMethods;
